var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"\n    text-center\n    h-100vh\n    d-flex\n    align-items-center\n    justify-content-center\n    bg-white\n  "},[_c('b-spinner',{staticClass:"m-5 spinner-main",attrs:{"label":"Loading...","variant":_vm.variant}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }